export const MATRIX_SORT_ROWS = [
	{
		label: 'None',
		value: 'None',
	},
	{
		label: 'Alphabetical',
		value: 'Alphabetical',
	},
	{
		label: 'By Value, Low to High',
		value: 'ValueLowToHigh',
	},
	{
		label: 'By Value, High to Low',
		value: 'ValueHighToLow',
	},
	{
		label: 'By Count, Low to High',
		value: 'CountLowToHigh',
	},
	{
		label: 'By Count, High to Low',
		value: 'CountHighToLow',
	},
	{
		label: 'Ordinal',
		value: 'Ordinal',
	},
]; 

export const MATRIX_SORT_COLS = [
	{
		label: 'None',
		value: 'None',
	},
	{
		label: 'Alphabetical',
		value: 'Alphabetical',
	},
	{
		label: 'Ordinal',
		value: 'Ordinal',
	}
]; 


export const MATRIX_AGGREGATION_METHOD_VALUES = [
	{
		label: 'Average',
		value: 'Average',
	},
	{
		label: 'Sum',
		value: 'Sum',
	}
]; 